import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function TermsModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Términos y Condiciones</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Al enviar este formulario, acepto que los datos proporcionados serán
          utilizados únicamente para fines de contacto por Sanus Esthetic.
          Declaro que soy mayor de edad o tengo autorización para facilitar la
          información. Acepto el tratamiento de mis datos de acuerdo con la ley
          de protección de datos personales.
        </p>
        {/* Agregue más contenido legal según sea necesario */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
